<template>
  <!-- 国内旅行対応 -->
  <div id="AppDomesticTravelSearchResult">
    <!-- 検索結果 -->
    <div class="columns">
      <div class="column is-two-thirds" style="text-align:left;">
        <b-button
          v-if="isBeforePatient"
          :disabled="editFlg||!isAdd"
          class="button is-primary has-text-centered"
          icon-left="calendar-plus"
          native-type="button"
          v-on:click="addTravel"
        >旅程追加</b-button>
        <b-button
          v-else
          :disabled="editFlg"
          class="button is-primary has-text-centered"
          icon-left="calendar-plus"
          native-type="button"
          v-on:click="addTravel"
        >旅程追加</b-button>
        <b-button
          class="button is-primary has-text-centered"
          icon-left="calendar-text"
          native-type="button"
          :disabled="checkedRows.length != 1 || editFlg"
          v-on:click="copyTravel"
        >旅程複写</b-button>
      </div>
      <div class="column">
        <b-field horizontal label="検索結果" style="float: right; white-space: nowrap;">
          <b-select position="is-right" v-model="perPage">
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="50">50</option>
          </b-select>
        </b-field>
      </div>
    </div>
    <div>
      <b-table
        :data="data"
        :paginated="isPaginated"
        :per-page="perPage"
        :current-page.sync="currentPage"
        :pagination-simple="isPaginationSimple"
        :pagination-position="paginationPosition"
        :pagination-size="paginationSize"
        :default-sort-direction="defaultSortDirection"
        default-sort="endDate"
        detailed
        checkable
        :checked-rows.sync="checkedRows"
        checkbox-position="left"
        aria-next-label="Next page"
        aria-previous-label="Previous page"
        aria-page-label="Page"
        aria-current-label="Current page"
      >
        <template slot-scope="props">
          <b-table-column
            field="patientCode"
            label="患者コード"
            sortable
            centered
          >{{ props.row.patientCode }}</b-table-column>
          <b-table-column
            field="patientName"
            label="患者名"
            sortable
            centered
          >{{ props.row.patientName }}</b-table-column>
          <b-table-column field="patientNameKana" label="患者名（カナ）" sortable centered>
            <template v-if="props.row.patientNameKana">{{props.row.patientNameKana}}</template>
          </b-table-column>
          <b-table-column
            field="hospitalName"
            label="医療機関名"
            sortable
            centered
          >{{ props.row.hospitalName }}</b-table-column>
          <b-table-column field="status" label="ステータス" sortable centered>
            <span
              :class="['tag',
                {'is-warning':props.row.status == 5},
                {'is-success':props.row.status == 4},
                {'is-dark':props.row.status == 3},
                {'is-danger':props.row.status == 2},
                {'is-info':props.row.status == 1}]"
            >{{ props.row.status | travelStatusFillter}}</span>
          </b-table-column>
          <b-table-column
            field="startDate"
            label="旅行期間"
            sortable
            centered
          >{{ props.row.startDate }}～{{ props.row.endDate }}</b-table-column>
          <b-table-column
            field="travelType"
            label="旅行種別"
            sortable
            centered
          >{{ props.row.travelType | travelTypeFillter }}</b-table-column>
          <b-table-column field="travelOfficeCode" label="旅行先営業所" sortable centered>
            <span
              v-for="(officeName,index) in getOfficeName(props.row.travelOfficeName)"
              :value="officeName"
              :key="index"
            >
              {{ officeName}}
              <br />
            </span>
          </b-table-column>
          <b-table-column field="configuration" label="編集" centered>
            <b-button
              v-if="props.row.status==0 || editFlg"
              class="button is-primary has-text-centered"
              icon-left="checkbox-multiple-blank-outline"
              native-type="button"
              v-on:click="editTravel(props.row.domesticTravelCode,props.row.status,editFlg)"
            ></b-button>
            <b-button
              v-else
              class="button is-primary has-text-centered"
              icon-left="mdi mdi-cog"
              native-type="button"
              v-on:click="editTravel(props.row.domesticTravelCode,props.row.status,editFlg)"
            ></b-button>
          </b-table-column>
        </template>
        <template slot="detail" slot-scope="props">
          <div class="content">
            <table style="table-layout: fixed;">
              <tr>
                <th style="width:250px;">連絡先：</th>
                <td>{{ props.row.patientPhone }}</td>
              </tr>
              <tr>
                <th style="width:250px;">同行者名：</th>
                <td>{{ props.row.companionName }}</td>
              </tr>
              <tr>
                <th style="width:250px;">同行者連絡先：</th>
                <td>{{ props.row.companionPhone }}</td>
              </tr>
              <tr>
                <th style="width:250px;">医療機関名／医師名：</th>
                <td>{{ props.row.hospitalName }} {{ props.row.doctorName }}</td>
              </tr>
              <tr>
                <th style="width:250px;">患者担当営業所：</th>
                <td>{{ props.row.inChargeOfficeCode|officeFilter(officeMaster) }}</td>
              </tr>
              <tr>
                <th style="width:250px;">旅程担当者／所属営業所：</th>
                <td>{{ props.row.staffName }} ／ {{ props.row.staffOfficeCode|officeFilter(officeMaster) }}</td>
              </tr>
              <tr>
                <th style="width:250px;">持参機器：</th>
                <td>
                  <span v-for="item in props.row.carryingItems" v-bind:key="item.productName">
                    {{ item.productName }}
                    <br />
                  </span>
                </td>
              </tr>
              <tr>
                <th>手配機器：</th>
                <td>{{ props.row.preparedItems }}</td>
              </tr>
              <tr>
                <th>移動手段：</th>
                <td>
                  <span v-for="item in props.row.transportations" v-bind:key="item">
                    {{ item }}
                    <br />
                  </span>
                </td>
              </tr>
            </table>
          </div>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
var data = [];
var officeMaster = [];
export default {
  name: "AppDomesticTravelSearchResult",
  props: [
    "searchConditions",
    "patientInfo",
    "currentPatient",
    "isBeforePatient",
    "isAdd"
  ],
  methods: {
    getOfficeName: function(value) {
      return value.split(",");
    },
    search: function(event) {
      this.checkedRows = [];
      if (this.searchConditions.patientCode !== this.currentPatient) {
        // 患者コードが変更された場合、currentPatientをクリアする
        this.currentPatient = "";
      }
      var excuteApi = this.getTravelListPOST;
      var successCallBack = this.getTravelListPOSTSuccess;
      var errorCallBack = this.getTravelListPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getTravelListPOST: function(client) {
      return client.apis.apiTravel.getTravelListPOST({
        body: {
          officeCode: this.searchConditions.officeCode,
          startDate: this.searchConditions.startDate,
          endDate: this.searchConditions.endDate,
          staffCode: this.searchConditions.staffCode,
          staffName: this.searchConditions.staffName,
          patientCode: this.searchConditions.patientCode,
          patientName: this.searchConditions.patientName,
          patientNameKana: this.searchConditions.patientNameKana,
          status: this.searchConditions.travelStatusGroup
        }
      });
    },
    getTravelListPOSTSuccess: function(result) {
      // WebAPI応答内容を画面に設定
      this.data = result.obj;
      for (var val in this.searchConditions.travelStatusGroup) {
        this.searchConditions.travelStatusGroup[val] =
          this.searchConditions.travelStatusGroup[val] + "";
      }
    },
    getTravelListPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
      for (var val in this.searchConditions.travelStatusGroup) {
        this.searchConditions.travelStatusGroup[val] =
          this.searchConditions.travelStatusGroup[val] + "";
      }
    },
    addTravel: function() {
      this.$router.push({
        name: "AppDomesticTravel",
        params: {
          type: "new",
          domesticTravelCode: "",
          searchConditions: this.searchConditions,
          patientInfo: this.$props.patientInfo
        }
      });
    },
    copyTravel: function() {
      this.$router.push({
        name: "AppDomesticTravel",
        params: {
          type: "copy",
          domesticTravelCode: this.$data.checkedRows[0].domesticTravelCode,
          searchConditions: this.searchConditions
        }
      });
    },
    editTravel: function(domesticTravelCode, status, editFlg) {
      this.$router.push({
        name: "AppDomesticTravel",
        params: {
          type: "edit",
          domesticTravelCode: domesticTravelCode,
          status: status,
          searchConditions: this.searchConditions,
          editFlg: editFlg
        }
      });
    }
  },
  data() {
    officeMaster = JSON.parse(sessionStorage.getItem("officeMaster"));
    var currentPatient = this.$props.currentPatient;
    var isBeforePatient = this.$props.isBeforePatient;
    var isAdd = this.$props.isAdd;
    var roleId = JSON.parse(sessionStorage.getItem("userInfo")).roleId;
    var editFlg = false;
    if (roleId == 2) {
      editFlg = true;
    }
    return {
      data,
      officeMaster,
      isPaginated: true,
      isPaginationSimple: false,
      paginationPosition: "top",
      paginationSize: "is-small",
      defaultSortDirection: "asc",
      defaultOpenedDetails: [1],
      currentPage: 1,
      perPage: 10,
      checkedRows: [],
      currentPatient,
      isBeforePatient,
      isAdd,
      editFlg
    };
  },
  filters: {
    officeFilter: function(value, officeMaster) {
      var officeElement = officeMaster.find(v => v.officeCode === value);
      if (officeElement) {
        return officeElement.officeName;
      }
      return "";
    }
  },
  components: {},
  mounted: function() {}
};
</script>



// WEBPACK FOOTER //
// src/components/AppDomesticTravelSearchResult.vue